import { request } from './client';
import type { AuditPage, AuditQuery } from '../types';

/** A failure seen in the browser, as the API takes it. */
export interface ClientErrorReport {
  message: string;
  stack?: string;
  url?: string;
  /** What raised it: render, error, rejection. */
  source?: string;
}

/** The audit log. Contract: docs/api/AUDIT.md. */
export const auditApi = {
  list: (query: AuditQuery = {}) => {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(query)) {
      if (value !== undefined && value !== '') params.set(key, String(value));
    }
    const qs = params.toString();
    return request<AuditPage>(`/audit${qs ? `?${qs}` : ''}`);
  },

  /** Sent in the background: a 401 must not take the person off their page. */
  reportClientError: (report: ClientErrorReport) =>
    request<void>('/audit/client-errors', { method: 'POST', body: JSON.stringify(report) }, { keepPage: true }),
};
